import { ChevronDown } from 'assets/icons';
import Button from 'components/button';

/**
 * « Voir plus » / « Voir moins », the pill of the mission description in
 * jobbiz_app_v2 (MissionDescription): white, framed, its chevron turning as
 * the list opens. At its own size by default; `fullWidth` where the column
 * leaves it the room (a record's « À propos »).
 */
const SeeMoreButton = ({ open, onClick, children, fullWidth = false }) => (
  <Button
    size="SM"
    color="SECONDARY"
    className={`mt-2 h-10 rounded-full font-semibold text-gray-800 ${fullWidth ? 'w-full' : 'self-start'}`}
    aria-expanded={open}
    onClick={onClick}
  >
    {children}
    <span className={`transition-transform ${open ? 'rotate-180' : ''}`}>
      <ChevronDown wh={18} color="currentColor" />
    </span>
  </Button>
);

export default SeeMoreButton;
